import { useState, lazy, Suspense } from "react";
import { HelpCircle } from "lucide-react";

const CoreSignalGuideDialog = lazy(() =>
  import("./CoreSignalGuideDialog").then((m) => ({
    default: m.CoreSignalGuideDialog,
  }))
);

interface CoreSignalGuideButtonProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function CoreSignalGuideButton({
  open: controlledOpen,
  onOpenChange: controlledOnOpenChange,
}: CoreSignalGuideButtonProps = {}) {
  const [internalOpen, setInternalOpen] = useState(false);

  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;
  const setOpen = isControlled ? controlledOnOpenChange! : setInternalOpen;

  return (
    <>
      {!isControlled && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="flex h-9 w-9 items-center justify-center rounded-lg border border-grid-200 bg-white text-ink-500 shadow-sm transition hover:border-grid-300 hover:text-ink-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-imperial-500"
          aria-label="Open user guide"
        >
          <HelpCircle className="h-4 w-4" />
        </button>
      )}

      {open && (
        <Suspense>
          <CoreSignalGuideDialog open={open} onOpenChange={setOpen} />
        </Suspense>
      )}
    </>
  );
}
